import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const withRouteParams = (...params: string[]): CanActivateFn => (route) => {
  const router = inject(Router);

  return params.every((param) => !!route.paramMap.get(param)) ? true : router.createUrlTree(['/']);
};